@if (carpetas.length) {
  <p
    class="mt-3 select-none px-2.5 text-[11px] font-semibold uppercase tracking-wider text-gray-500">{{ 'CARPETAS' | translate }}</p>
}
<ul class="mt-1 space-y-0.5" role="list">
  @for (carpeta of carpetas; track carpeta.id) {
    <li
      (dragover)="onDragOver($event, carpeta)"
      (dragenter)="onDragEnter($event, undefined, 1)"
      (drop)="onDrop($event, carpeta)"
      (dragleave)="onDragLeave($event, carpeta, 1)">
      <div (click)="toggleCarpeta(carpeta)" (keydown.enter)="toggleCarpeta(carpeta)"
           [ngClass]="{'bg-indigo-100': carpeta.dragOn}"
           class="group relative flex w-full items-center gap-x-2 rounded-md px-2.5 py-2 text-sm font-medium leading-6 text-indigo-600 c-pointer hover:bg-indigo-100 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
           role="button"
           tabindex="0">
        @if (carpeta.dragOn) {
          <svg class="h-6 w-6 shrink-0" fill="none" stroke="currentColor" stroke-width="1.5"
               viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        } @else if (carpeta.abierta) {
          <svg class="h-6 w-6 shrink-0" fill="none" stroke="currentColor" stroke-width="1.5"
               viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        } @else {
          <svg class="h-6 w-6 shrink-0" fill="none" stroke="currentColor" stroke-width="1.5"
               viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        }
        <span class="flex-1 truncate text-left select-none">{{ carpeta.descripcion }}</span>
        <span
          class="absolute right-1.5 top-1/2 flex -translate-y-1/2 items-center gap-x-0.5 rounded-sm bg-white pl-1 text-indigo-400 lg:hidden lg:bg-indigo-100 lg:group-hover:flex">
          <button (click)="editarCarpeta(carpeta, $event)" aria-label="{{'Editar carpeta' | translate}}" class="rounded-sm p-1 hover:bg-black/5 hover:text-indigo-700"
            title="{{'Editar carpeta' | translate}}"
                  type="button">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </button>
          <button (click)="confirmarBorradoCarpeta(carpeta, $event)" aria-label="{{'Borrar carpeta' | translate}}" class="rounded-sm p-1 hover:bg-black/5 hover:text-red-600"
            title="{{'Borrar carpeta' | translate}}"
                  type="button">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </button>
        </span>
      </div>
      @if (carpeta.abierta) {
        <div class="ml-[22px] mt-0.5 border-l border-gray-200 pl-2">
          @if (carpeta.conversaciones && carpeta.conversaciones.length === 0) {
            <p class="select-none px-2.5 py-1.5 text-xs text-gray-400">
              {{ 'No hay conversaciones en esta carpeta.' | translate }}
            </p>
          }
          <ul class="space-y-0.5" role="list">
            @for (mes of carpeta.conversaciones; track mes.mes) {
              @for (conversacion of mes.conversaciones; track conversacion.id) {
                <li>
                  <div (click)="navegarChat(conversacion, $event)" (keydown.enter)="navegarChat(conversacion, $event)"
                       [ngClass]="conversacionActiva(conversacion.id) ? 'bg-indigo-50 font-medium text-indigo-700' : 'text-gray-700 hover:bg-gray-50'"
                       class="group relative flex w-full items-center rounded-md px-2.5 py-1.5 text-sm leading-6 c-pointer focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    draggable="true"
                    (dragstart)="onDragStart($event, conversacion)"
                       role="button"
                       tabindex="0"
                       title="{{conversacion.asunto}} ({{conversacion.fecha | date:'dd/MM/YYYY'}})">
                    <span class="flex-1 truncate text-left select-none">{{ conversacion.asunto }}</span>
                    @if (!conversacion.dragOn) {
                      <span
                        [ngClass]="conversacionActiva(conversacion.id) ? 'bg-indigo-50 text-indigo-400' : 'bg-white text-gray-400 lg:bg-gray-50'"
                        class="absolute right-1.5 top-1/2 flex -translate-y-1/2 items-center gap-x-0.5 rounded-sm pl-1 lg:hidden lg:group-hover:flex">
                        <button aria-label="{{'Editar conversación' | translate}}" class="rounded-sm p-1 hover:bg-black/5 hover:text-gray-700"
                                title="{{'Editar conversación' | translate}}"
                          (click)="editarConversacion(conversacion, $event)"
                                type="button">
                          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5"
                               viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                          </svg>
                        </button>
                        <button aria-label="{{'Borrar conversación' | translate}}" class="rounded-sm p-1 hover:bg-black/5 hover:text-red-600"
                                title="{{'Borrar conversación' | translate}}"
                          (click)="confirmarBorrado(conversacion, $event, carpeta)"
                                type="button">
                          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5"
                               viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </span>
                    }
                  </div>
                </li>
              }
            }
          </ul>
        </div>
      }
    </li>
  }
</ul>
<div class="min-h-52"
  (dragenter)="onDragEnter($event, undefined, 2)"
  (dragover)="onDragOver($event, undefined)"
  (dragleave)="onDragLeave($event, undefined, 2)"
  (drop)="onDrop($event, undefined)">
  <p
    class="mt-4 select-none px-2.5 text-[11px] font-semibold uppercase tracking-wider text-gray-500">{{ 'CONVERSACIONES' | translate }}</p>
  @if (mostrarPrevisualizacion && !esConversacionBloqueGeneral) {
    <div
      class="mt-1 rounded-md border-2 border-dashed border-indigo-400 bg-indigo-50 px-2.5 py-1.5 text-sm leading-6 text-indigo-400">
      <span class="block truncate">{{ tituloConversacionAMover }}</span>
    </div>
  }
  @for (mes of conversacionesMes; track mes.mes) {
    <p class="mt-3 select-none px-2.5 pb-0.5 text-xs font-medium text-gray-400">{{ mes.mes | titlecase }}</p>
    <ul class="space-y-0.5" role="list">
      @for (conversacion of mes.conversaciones; track conversacion.id) {
        <li>
          <div (click)="navegarChat(conversacion, $event)" (keydown.enter)="navegarChat(conversacion, $event)"
               [ngClass]="conversacionActiva(conversacion.id) ? 'bg-indigo-50 font-medium text-indigo-700' : 'text-gray-700 hover:bg-gray-50'"
               class="group relative flex w-full items-center rounded-md px-2.5 py-1.5 text-sm leading-6 c-pointer focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            draggable="true"
            (dragstart)="onDragStart($event, conversacion)"
               role="button"
               tabindex="0"
               title="{{conversacion.asunto}} ({{conversacion.fecha | date:'dd/MM/YYYY'}})">
            <span class="flex-1 truncate text-left select-none">{{ conversacion.asunto }}</span>
            @if (!conversacion.dragOn) {
              <span
                [ngClass]="conversacionActiva(conversacion.id) ? 'bg-indigo-50 text-indigo-400' : 'bg-white text-gray-400 lg:bg-gray-50'"
                class="absolute right-1.5 top-1/2 flex -translate-y-1/2 items-center gap-x-0.5 rounded-sm pl-1 lg:hidden lg:group-hover:flex">
                <button (click)="editarConversacion(conversacion, $event)" aria-label="{{'Editar conversación' | translate}}"
                        class="rounded-sm p-1 hover:bg-black/5 hover:text-gray-700"
                  title="{{'Editar conversación' | translate}}"
                        type="button">
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5"
                       viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </button>
                <button (click)="confirmarBorrado(conversacion, $event, null)" aria-label="{{'Borrar conversación' | translate}}"
                        class="rounded-sm p-1 hover:bg-black/5 hover:text-red-600"
                  title="{{'Borrar conversación' | translate}}"
                        type="button">
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5"
                       viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </button>
              </span>
            }
          </div>
        </li>
      }
    </ul>
    } @empty {
    @if (!mostrarPrevisualizacion) {
      <p class="mt-1 select-none px-2.5 text-xs text-gray-400">
        {{ 'No hay ninguna conversación' | translate }}
      </p>
    }
  }
</div>
